import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-land-page',
  templateUrl: './land-page.component.html',
  styles: [
  ]
})
export class LandPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
